import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Typewriter from './Typewriter';

export  function Banner() {

    const navigate = useNavigate();
    const { t } = useTranslation();
    const [titleDone, setTitleDone] = useState(false);
    const [reduced] = useState(() =>
        typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );

    const handleClickContact = (e) => {
        e.preventDefault();
        navigate('/contact');
      }

    return (
        <>
            <div className="container-grey reveal">

                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                                <h1 className="text-right mb-6">
                                    <Typewriter
                                        noAnimation={reduced}
                                        speed={30}
                                        startDelay={150}
                                        onDone={() => setTitleDone(true)}
                                        script={[
                                            { t: '\u201CWe make' },
                                            { t: '', br: true },
                                            { t: 'digital ' },
                                            { t: 'easy', spans: true },
                                            { t: '\u201D' },
                                        ]}
                                    />
                                </h1>
                                <div className="separar"></div>
                                <h2 className={`text-right typing-subtitle ${titleDone ? 'is-visible' : ''}`}>{t("index.banner.subtitle1")}<br/>{t("index.banner.subtitle2")}</h2>
                                <div className="separar"></div>
                                <a href="javascript:void();" onClick={(e) => handleClickContact(e)} className="btn btn-primary float-right">{t("index.banner.button")}</a>
                                <div className="separar"></div>
                                <div className="separar"></div>
                                <div className="separar"></div>
                                <div id="carouselIndicators" className="carousel slide  d-sm-block d-md-block d-lg-block d-xl-block" data-ride="carousel">
                                    <ol className="carousel-indicators">
                                        <li data-target="#carouselIndicators" data-slide-to="0" className="active"></li>
                                        <li data-target="#carouselIndicators" data-slide-to="1"></li>
                                    </ol>
                                    <div className="carousel-inner">
                                        <div className="carousel-item active">
                                            <div className="hero-home mt-6">
                                                <h3>{t("index.banner.card_title")}</h3>
                                                <p className="mt-3">{t("index.banner.card_content")}</p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <div className="hero-home mt-6">
                                                <h3>{t("index.banner.card_title2")}</h3>
                                                <p className="mt-3">{t("index.banner.card_content2")}</p>
                                            </div>
                                        </div>
                                    </div>   
                                </div>
                        </div>
                    </div>
                </div>

                </div>
        </>
        
        )
}

export default Banner